import React from "react";
import { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { BASE_API_URL } from "../constant";
// import tringlogo from "../images/tring.png";

function Register() {
    const [phoneNumber, setPhoneNumber] = useState("");
    const [password, setPassword] = useState("");
    const [name, setName] = useState("");
    const [age, setAge] = useState("");
    const [gender, setGender] = useState("");
    const [ip, setIp] = useState("");

    //OTP
    const [isOtpSent, setIsOtpSent] = useState(false);
    const [otp, setOtp] = useState('');
    const [sentOtp, setSentOtp] = useState('');
    const [verified, setVerified] = useState(false);
    //OTP

    const navigate = useNavigate();

    axios.get("https://api.ipify.org/?format=json").then((res) => {
        setIp(res.data.ip);
    });

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            await axios.post(BASE_API_URL + "api/user/register", {
                phoneNumber,
                username: name,
                age,
                gender,
                language: "",
                ip_address: ip,
                location: "",
                region: "",
                password,
            }).then((res) => {
                if (res.status === 201) {
                    alert(res.data.message);
                }
                if (res.status === 408) {
                    alert(res.data.message);
                }
            })
            navigate("/user/login");
        } catch (err) {
            alert("User already exists with this phone number");
        }
    }

    //OTP
    const handleSendOtp = async () => {
        // Validate phone number (you can add your validation logic)
        if (!phoneNumber) {
            alert('Error', 'Please enter a valid phone number.');
            return;
        }
        if (phoneNumber.length < 10) {
            alert("Error, Please add a valid phone number.");
        }
        const randomNumber = Math.floor(1000 + Math.random() * 9000);

        const fourDigitOTP = ('000' + randomNumber).slice(-4);
        setSentOtp(fourDigitOTP);
        console.log('====================================');
        console.log(fourDigitOTP);
        console.log(sentOtp);
        console.log('====================================');

        await axios.get(`https://smslogin.co/v3/api.php?username=JKDEVI&apikey=0c3d970adcb15c0f85fc&mobile=${phoneNumber}&senderid=IPEMAA&message=Here+is+your+OTP+${fourDigitOTP}+for+Knowledge+Day+Registration+at+Poultry+India+2023.`);
        setIsOtpSent(true);
    };

    const handleVerifyOtp = () => {
        // Simulate OTP verification logic
        const expectedOtp = sentOtp; // Replace with the actual OTP received or generated
        if (otp === expectedOtp) {
            alert('Success', 'OTP verified successfully!');
            setVerified(true);
        } else {
            alert('Error', 'Incorrect OTP. Please try again.');
        }
    };
    //OTP

    return (
        <div className="d-flex justify-content-center align-items-center">
            <div className="bg-white p-3">
                {/* <div className="mb-3">
                    <img width="200px" src={tringlogo} alt="tring-logo" />
                </div> */}
                <h2 className="text-center mb-3">Register</h2>
                <form onSubmit={handleSubmit} >
                    <div className="form-group mb-3">
                        {!isOtpSent ?
                            <>
                                <label htmlFor="phoneNumber">Phone Number</label>
                                <input required type="phoneNumber" className="form-control" id="phoneNumber" placeholder="Enter Phone Number" value={phoneNumber} onChange={(e) => setPhoneNumber(e.target.value)} />
                                <button onClick={handleSendOtp} type="submit" className="btn btn-success w-100 rounded-0">Send OTP</button>
                            </>
                            :
                            <>
                                <label htmlFor="otp">Enter OTP</label>
                                <input required type="otp" className="form-control" id="otp" placeholder="Enter OTP" value={otp} onChange={(e) => setOtp(e.target.value)} />
                                {
                                    verified ?
                                        <h3 className="text-success text-center mb-3">Mobile Number Verified !</h3>
                                        :
                                        <button onClick={handleVerifyOtp} type="submit" className="btn btn-success w-100 rounded-0">Verify OTP</button>
                                }
                            </>
                        }
                    </div>
                    <div className="form-group mb-3">
                        <label htmlFor="name">Name</label>
                        <input required type="name" className="form-control" id="name" placeholder="Enter Name" value={name} onChange={(e) => setName(e.target.value)} />
                    </div>
                    <div className="form-group mb-3">
                        <label htmlFor="age"> Age</label>
                        <input required type="age" className="form-control" id="age" placeholder="Enter Age" value={age} onChange={(e) => setAge(e.target.value)} />
                    </div>
                    <div className="form-group mb-3">
                        <label htmlFor="gender">Gender</label>
                        <select required className="form-control" id="gender" value={gender} onChange={(e) => setGender(e.target.value)}>
                            <option value="Male" >Male</option>
                            <option value="Female" >Female</option>
                            <option value="Others" >Others</option>
                        </select>
                    </div>
                    <div className="form-group mb-3">
                        <label htmlFor="password">Password</label>
                        <input required type="password" className="form-control" id="password" placeholder="Enter Password" value={password} onChange={(e) => setPassword(e.target.value)} />
                    </div>
                    {
                        verified ?
                            <button type="submit" className="btn btn-success w-100 rounded-0">Register</button>
                            :
                            <h5 className="text-danger text-center mb-3">Verify Your Number First !!!</h5>
                    }
                </form>
                <p className="text-center mt-3">Already have an account? <a href="/user/login" className="text-decoration-none">Login</a></p>
            </div>
        </div>
    )
}
export default Register;